import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../common-service/common.service';
import {SecurityService} from '../security/security.service';
import {RoleGuardService} from '../role-guard/role-guard.service';
import { AppsettingsProvider } from '../appsettings.provider';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  currentPage = 'Home';
  iframeUrl: string = '';
  showDarwinIframe: boolean = false;

  constructor(
      private _common: CommonService,
      private _securityService: SecurityService,
      private _appSettings: AppsettingsProvider,
      private _roleGuard: RoleGuardService
  ) {
  }

  ngOnInit() {
  }

  getCurrentPage() {
    return this._common.getCurrentPage();
  }

  toggleNavigationPane() {
    this._common.toggleNavigationPane();
  }

  checkLogin() {
    return this._securityService.isLoggedIn();
  }

  isUnauthorizedReason() {
    return !!this._securityService.getUnauthorizedReasonFromToken();
  }

  isDarwinActive() {
    return this._common.operation && 
           this._common.operation.isOnAskCanteen &&
           this._roleGuard.hasOneOfRoles(['ASK_CANTEEN_INTERNAL_USER', 'ASK_CANTEEN_BASIC_ACCESS']);
  }

  toggleDarwinIframe() {
    this.showDarwinIframe = !this.showDarwinIframe;
    if (this.showDarwinIframe) {
      const url = this._appSettings.getSettings().urlLocations.askCanteenURL;
      this.iframeUrl = url;
    }
  }
}
